// extracted by mini-css-extract-plugin
export default {"pageContainer":"P2EGames_pageContainer__NAolG","gamesList":"P2EGames_gamesList__cDHCl","gameCard":"P2EGames_gameCard__S+MO7","gameImage":"P2EGames_gameImage__mt5lg"};